/**
 * @public
 */
export var VideoFormat;
(function (VideoFormat) {
    VideoFormat["HD"] = "HD";
    VideoFormat["SD"] = "SD";
    VideoFormat["UHD"] = "UHD";
})(VideoFormat || (VideoFormat = {}));
/**
 * @public
 */
export var VideoColourSpace;
(function (VideoColourSpace) {
    VideoColourSpace["DV"] = "DV";
    VideoColourSpace["HDR10"] = "HDR10";
    VideoColourSpace["HDRHLG"] = "HDRHLG";
    VideoColourSpace["SDR"] = "SDR";
})(VideoColourSpace || (VideoColourSpace = {}));
/**
 * @public
 */
export var VideoCodec;
(function (VideoCodec) {
    VideoCodec["H264"] = "H264";
    VideoCodec["H265"] = "H265";
})(VideoCodec || (VideoCodec = {}));
/**
 * @public
 */
export var HdcpLevel;
(function (HdcpLevel) {
    HdcpLevel["Disconnected"] = "Disconnected";
    HdcpLevel["NoSupport"] = "NoSupport";
    HdcpLevel["Unknown"] = "Unknown";
    HdcpLevel["V1"] = "1.0";
    HdcpLevel["V1_4"] = "1.4";
    HdcpLevel["V2"] = "2.0";
    HdcpLevel["V2_1"] = "2.1";
    HdcpLevel["V2_2"] = "2.2";
    HdcpLevel["V2_3"] = "2.3";
})(HdcpLevel || (HdcpLevel = {}));
//# sourceMappingURL=video-format.js.map